<script setup>
import { Icon } from "@iconify/vue";
import { reactive, ref, onMounted } from "vue";
import Swal from "sweetalert2";
import { VueSidePanel } from "vue3-side-panel";
import axios from "axios";
import { formatDate } from "@vueuse/core";
import { usePage } from "@inertiajs/inertia-vue3";

const open = reactive({ side: false });
const currentUrl = ref("");

const formData = reactive({
  type: "",
  priority: "",
  description: "",
  first_name:"",
  page_link: "",
});

onMounted(() => {
  resetFormData();
  formData.page_link = window.location.href;
});

const resetFormData = () => {
  formData.type = "";
  formData.priority = 0;
  formData.description = "";
  formData.first_name = "";
  formData.page_link = window.location.href;
};

const handleType = (type) => {
  formData.type = type;
};

const saveBug = async () => {
  if (formData.priority === 0) {
    alert("Veuillez sélectionner un niveau de priorité.");
    return;
  }
  if (formData.first_name?.length === 0) {
    alert("Veuillez indiquer votre prénom pour un meilleur suivi.");
    return;
  }
  let userId = usePage().props.value.auth.user.id


  formData.user_id = userId

  try {
    await axios.post("/api/reporting", formData);
    open.side = false;
    let typeText = "";

    if (formData.type === "bug") {
      typeText = "Le bug a bien été signalé !";
    } else if (formData.type === "dev") {
      typeText = "La demande de développement a bien été pris en compte !";
    }

    await Swal.fire({
      title: "Merci !",
      text: typeText,
      icon: "success",
      showConfirmButton: false,
      timer: 1800,
      timerProgressBar: true,
    });
  } catch (error) {
    alert("Un problème est survenu. Veuillez recommencer...");
  }
};
</script>

<template>
  <div>
    <button
      class="rounded-full border p-2 bg-primary transform duration-200 hover:p-3 group"
      @click="open.side = true"
    >
      <Icon
        icon="hugeicons:message-upload-02"
        class="w-6 h-6 group-hover:w-10 group-hover:h-10 transform duration-200 delay-100"
      />
    </button>
  </div>
  <VueSidePanel
    v-model="open.side"
    width="100%"
    height="80%"
    side="bottom"
    rerender
    hide-close-btn
    lock-scroll
  >
    <div class="bg-primary min-h-full">
      <div class="flex items-center justify-center p-3">
        <h2 class="text-2xl uppercase">
          Remontée de bugs ou demande de développement
        </h2>
      </div>
      <div class="pt-12">
        <div class="flex items-center justify-center space-x-12">
          <button
            @click="handleType('bug')"
            :class="[
              'border rounded-xl p-4 w-80 flex flex-col items-center justify-center transform duration-300 hover:bg-primaryT hover:text-primary',
              formData.type == 'bug' && 'bg-primaryT text-primary',
            ]"
          >
            <span class="font-sulphurPoint text-sm">Signaler</span>
            <span class="uppercase font-sulphurPoint text-3xl">un bug</span>
          </button>
          <button
            @click="handleType('dev')"
            :class="[
              'border rounded-xl p-4 w-80 flex flex-col items-center justify-center transform duration-300 hover:bg-primaryT hover:text-primary',
              formData.type == 'dev' && 'bg-primaryT text-primary',
            ]"
          >
            <span class="font-sulphurPoint text-sm">Demander</span>
            <span class="uppercase font-sulphurPoint text-3xl"
              >un développement</span
            >
          </button>
        </div>
      </div>
      <!-- Formulaire -->
      <div class="flex justify-center mt-6" v-if="formData.type">
        <form @submit.prevent="saveBug" class="flex flex-col w-7/12">
          <div class="m-2">
            <select
              v-model="formData.priority"
              class="input bg-primary py-2 pl-4 pr-12 border border-primaryT text-xs"
            >
              <option value="0">Niveau de criticité</option>
              <option value="1">Mineur</option>
              <option value="2">Important</option>
              <option value="3">Urgent</option>
            </select>
          </div>
          <div class="relative m-2">
              <label class="absolute -top-2 left-2 bg-primary px-2 text-xs"
                >Votre prénom</label
              >
              <input
                onfocus="this.select()"
                v-model="formData.first_name"
                type="text"
                class="w-full input bg-primary border border-primaryT"
              />
          </div>
          <div class="m-2">
            <div class="relative">
              <label class="absolute -top-2 left-2 bg-primary px-2 text-xs"
                >Description</label
              >
              <textarea
                required
                v-model="formData.description"
                class="rounded-lg bg-primary border border-primaryT p-4 h-32 w-full"
              ></textarea>
            </div>
          </div>
          <div class="m-2">
            <div class="relative">
              <label class="absolute -top-2 left-2 bg-primary px-2 text-xs"
                >Lien de la page</label
              >
              <input
                onfocus="this.select()"
                v-model="formData.page_link"
                type="text"
                class="w-full input bg-primary border border-primaryT"
              />
              <div
                class="alert info my-4 flex items-center justify-between space-x-6"
              >
                <Icon icon="solar:arrow-up-linear" width="36" height="36" />
                <div>
                  <p class="text-xs font-prompt">
                    Le lien de la page actuelle.
                  </p>
                  <p class="text-xs font-prompt">
                    Si le problème est sur une autre page, merci de copier
                    coller l'adresse de la page en question et la remplacer ici
                  </p>
                  <p class="text-xs font-prompt">
                    Sinon, vous pouvez aussi l'effacer si la page n'existe pas ou vous ne la connaissez pas.
                  </p>
                </div>
                <Icon icon="solar:arrow-up-linear" width="36" height="36" />
              </div>
            </div>
          </div>
          <div class="flex justify-end m-4">
            <button type="submit" class="btn btn-secondary">Envoyer</button>
          </div>
        </form>
      </div>
    </div>
  </VueSidePanel>
</template>

<style scoped>
</style>
